module.exports = __webpack_public_path__ + "characterAndLeadership-07615ee9d9dd75cc696d56ffaa022c32.svg";